module.exports = __webpack_public_path__ + "img/member-card.f5a1fe8c.svg";